import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { useHistory } from 'react-router-dom'
import styled from '@emotion/styled/macro'
import moment from 'moment'

// export const AUCTION_START = 'Thu Jun 06 2022 18:56:40 GMT-0400'
export const AUCTION_START = '2022-12-07T00:00:00-00:00'

const WrapperWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(131.58deg, #09101e 14.22%, #03070e 73.51%);
`

const Wrapper = styled(motion.div)`
  margin: 0;
  height: 100vh;
  position: relative;
  width: 63%;
  display: flex;
  justify-content: center;
  font-family: 'Poppins';

  @media (max-width: 960px) {
    width: 90%;
    margin-bottom: 160px;
  }
`

const Background = styled.div`
  text-align: center;
  background: black;
  width: 100%;
  display: flex;
  gap: 24px;
  flex-direction: column;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid transparent;
  cursor: pointer;
  background: #0b0e15;
  background-clip: padding-box;
  align-items: center;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    margin: -1px;
    border-radius: inherit;
    background: linear-gradient(100.39deg, #faaef2 17.63%, #9989ff 95.3%);
  }
`

const BackgroundWrapper = styled.div`
  margin-top: 26px;
  display: flex;
  flex-direction: column;
  gap: 36px;
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translate(0, -50%);
  display: flex;
  flex-direction: column;
`

const BlogPostText = styled.div`
  margin-top: -8px;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
`

const BlogPostLink = styled.span`
  position: relative;
  cursor: pointer;
  font-weight: 600;
  background: linear-gradient(100.39deg, #faaef2 17.63%, #9989ff 95.3%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  :before {
    content: '';
    position: absolute;
    top: 90%;
    width: 100%;
    left: 0;
    height: 1px;
    background: linear-gradient(100.39deg, #faaef2 17.63%, #9989ff 95.3%);
  }
`

const LaunchTitle = styled.div`
  width: fit-content;
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 16px;
`

const LaunchLogo = styled.img`
  fill: #fe3dce;
  height: auto;
  width: 36px;
  display: flex;
  align-items: center;
  pointer-events: auto;
  &:hover {
    cursor: pointer;
  }
`

const LaunchText = styled.div`
  width: 100%;
  font-weight: 600;
  font-size: 24px;
  color: #ffffff;
  @media (max-width: 600px) {
    font-size: 20px;
  }
`

const LaunchWord = styled.span`
  background: linear-gradient(100.39deg, #faaef2 17.63%, #9989ff 95.3%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

const StartText = styled.div`
  font-size: 12px;
  text-align: center;
  color: #ffffff99;
`

const Countdown = styled.div`
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  color: #ffffffc4;

  @media (max-width: 600px) {
    font-size: 14px;
  }
`

const TransitionImage = styled.img`
  user-select: none;
  position: absolute;
  right: 16%;
  bottom: 0;
  transform: translate(50%, 50%);
  width: 73.2%;
  z-index: -1;

  @media (max-width: 600px) {
    font-size: 14px;
    right: 50%;
    bottom: 50%;
    width: 100%;
  }
`

const animation = {
  initial: {
    scale: 0,
    opacity: 0
  },
  animate: {
    opacity: 1,
    scale: 1
  }
}

export default ({ match }) => {
  const [now, setNow] = useState(moment())

  const formatCountdownNumbers = time => {
    const numbers = time.map(t => {
      if (String(Math.floor(t)).length == 1) return `0${t}`
      return `${t}`
    })
    const [days, hours, minutes, seconds] = numbers
    return `${days} Days - ${hours} hours - ${minutes} minutes - ${seconds} seconds`
  }

  const countdown = () => {
    if (now.unix() < moment(AUCTION_START).unix()) {
      const duration = moment.duration(moment(AUCTION_START).diff(now))
      const { days, hours, minutes, seconds } = duration._data
      return formatCountdownNumbers([days, hours, minutes, seconds])
    } else {
      return 'Click here to enter the app'
    }
  }

  const runUpdater = () => {
    console.log(moment().unix())
    setTimeout(() => {
      setNow(moment())
    }, 1000)
  }

  const bannerClicked = () => {
    if (now.unix() < moment(AUCTION_START).unix()) {
      window.location =
        'https://twitter.com/EvmosDomains/status/1530626436574457856'
    } else {
      window.location.reload()
    }
  }

  const openBlogPost = () => {
    window.open(
      'https://blog.evmos.domains/the-evmos-domains-mainnet-launch-596ac1a50936'
    )
  }

  runUpdater()

  return (
    <WrapperWrapper>
      <Wrapper initial={animation.initial} animate={animation.animate}>
        <BackgroundWrapper>
          <Background onClick={bannerClicked}>
            <LaunchTitle>
              <LaunchLogo src="/logo.svg" />
              {now.unix() < moment(AUCTION_START).unix() ? (
                <LaunchText>
                  Mainnet <LaunchWord>launch</LaunchWord> in:
                </LaunchText>
              ) : (
                <LaunchText>
                  Mainnet has <LaunchWord>launched</LaunchWord>!
                </LaunchText>
              )}
            </LaunchTitle>
            <Countdown>{countdown()}</Countdown>
          </Background>
          <StartText>
            **Mainnet registrations begin here on 06/07/2022 at 00:00:00 UTC**
          </StartText>
          <BlogPostText>
            More details about pre-registration and names can be found in our
            official{' '}
            <BlogPostLink onClick={openBlogPost}>Launch Post</BlogPostLink>
          </BlogPostText>
        </BackgroundWrapper>
      </Wrapper>
    </WrapperWrapper>
  )
}
